import { useState } from "react";
import { Navigation } from "../components/sections/Navigation";
import { CareersHero } from "../components/sections/careers/CareersHero";
import { WhyTheWork } from "../components/sections/careers/WhyTheWork";
import { Perks, OpenRoles } from "../components/sections/careers/OpenRoles";
import { RecruitmentPartners } from "../components/sections/careers/RecruitmentPartners";
import { ApplicationForm } from "../components/sections/careers/ApplicationForm";
import { Contact } from "../components/sections/Contact";

export default function CareersPage() {
  const [activeRole, setActiveRole] = useState(null);

  return (
    <main data-testid="careers-page" className="relative bg-bone text-ink min-h-screen">
      <Navigation />
      <CareersHero />
      <WhyTheWork />
      <Perks />
      <OpenRoles onApply={setActiveRole} />
      <RecruitmentPartners />
      <Contact />

      {activeRole && (
        <ApplicationForm role={activeRole} onClose={() => setActiveRole(null)} />
      )}
    </main>
  );
}
